import { render, staticRenderFns } from "./SettingsRelatedParty.vue?vue&type=template&id=20b112d0&scoped=true&"
import script from "./SettingsRelatedParty.vue?vue&type=script&lang=js&"
export * from "./SettingsRelatedParty.vue?vue&type=script&lang=js&"
import style0 from "./SettingsRelatedParty.vue?vue&type=style&index=0&id=20b112d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b112d0",
  null
  
)

export default component.exports